/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';

import { pulse, glow } from 'solis/react/board/highlights/animation';


const Ring = styled.polygon`
  ${glow}
  ${pulse}

  fill: none;

  stroke: var(--accent-a6);

  stroke-width: ${({ hexGeometry }) => hexGeometry.getExternalBorderWidth()};
`;


const getPoints = ({ zoneGeometry }) =>
{
  return zoneGeometry.getPoints().map(({ x, y }) => `${x},${y}`).join(' ');
};


export default (props) =>
{
  return <Ring {...props} points = {getPoints(props)} />;
};
